import { Badge, Flex, Text, VStack } from '@chakra-ui/react'
import { differenceInWeeks } from 'date-fns';
import { riskColor, riskLabel } from 'enums/labelRisks';
import { findLastEvaluationInAssessmentsByTag, findLastMetricInAssessmentsByTag } from 'functions/lives/metrics';
import { Assessment } from 'interfaces/assessment';
import { Life } from 'interfaces/life';

interface Props {
    life: Life
}

interface BadgeProps {
    colorScheme: string
    label: string
    value?: string
}

const showGestationalAge = (gestationalAge: number | null, lastAssessmentAnsweredAt: Date | null | undefined): string => {
    if(!gestationalAge || gestationalAge == null || lastAssessmentAnsweredAt == null)
        return "Não Atribuído";
    else if(gestationalAge > 40)
        return "N/A";

    if(!lastAssessmentAnsweredAt || lastAssessmentAnsweredAt == null)
        return `${gestationalAge.toString()} semanas`;

    const gestationalAgePlusWeekDiff = gestationalAge + addWeeksToGestationalAge(lastAssessmentAnsweredAt);

    if(gestationalAgePlusWeekDiff > 40)
        return "N/A";

    return `${gestationalAgePlusWeekDiff.toString()} semanas`;
}

const addWeeksToGestationalAge = (evaluationDate: Date): number => {
    const today = new Date();
    const evaluationDateFormat = new Date(evaluationDate);
    const diffInWeeks = differenceInWeeks(today, evaluationDateFormat);

    return diffInWeeks;
}

const findLastAssessment = (assessments: Assessment[]): Assessment | null => {
    if(assessments == null)
        return null;

    let orderAssessments = [...assessments];
    orderAssessments = orderAssessments?.sort((a, b) => new Date(a.created_at).valueOf() - new Date(b.created_at).valueOf());

    return orderAssessments[0];
}

const DetailBox = ({ colorScheme, label, value }: BadgeProps) => (
    <Flex flex={1} border="1px solid" borderRadius={8} p={4} mx={2} minH="180px" justifyContent="center" alignItems="center">
        <VStack mr={8} alignItems="center">
            <Text fontSize="xl" fontWeight="bold">{label}</Text>
            <Badge fontSize="lg" py={2} px={3} colorScheme={colorScheme} variant="solid">{value}</Badge>
        </VStack>
    </Flex>
)

const DetailBadge = ({ colorScheme, label }: BadgeProps) => <Badge py={2} px={3} colorScheme={colorScheme} variant="solid">{label}</Badge>


const BirthDetails = ({ life }: Props) => {
    const risk = findLastMetricInAssessmentsByTag(life?.assessments || [], 'risco_gestacional') || '';
    const evaluation = findLastEvaluationInAssessmentsByTag(life?.assessments || [], 'imc');
    const evaluationData = evaluation ? JSON.parse(evaluation.data) : null

    const lastAssessment = findLastAssessment(life.assessments)

    return (
        <Flex mb="8px">
            <DetailBox 
                colorScheme={!risk ? "gray" : riskColor[risk as keyof typeof riskColor]} 
                label="Risco Gestacional" 
                value={!risk ? "Não atribuído" : riskLabel[risk as keyof typeof riskLabel]} 
            />
            <DetailBox
                colorScheme={evaluationData?.gestational_age ? "green" : "gray"}
                label="Idade Gestacional" 
                value={showGestationalAge(evaluationData?.gestational_age, lastAssessment?.answered_at)}
                // value={evaluationData?.gestational_age ? `${evaluationData?.gestational_age + addWeeksToGestationalAge(lastAssessment.answered_at)} semanas` : "Não atribuído"} 
            />
        </Flex>
    )
}

export default BirthDetails